import { all } from "redux-saga/effects";
import sagaUtils from "../sagaUtils";
import deviceRequestFunction from "./deviceRequestFunctions";

export default function* rootSaga() {
  yield all(sagaUtils.extractRequestFunctions(deviceRequestFunction));
}
